// import Navbar from "./navbar";
import React from "react";

import intropic from "../images/bg-pattern-intro-right-desktop.svg";
import intropicbig from "../images/image-intro-desktop.jpg";
import intropicbig_mobile from "../images/image-intro-mobile.jpg";

const Introduction = () => {
  return (
    <>
      <img
        className="introphotobigmobile"
        src={intropicbig_mobile}
        alt="nothing to see here"
      ></img>
      <div className="introduction">
        <img className="introphoto" src={intropic} alt="nothing"></img>

        <img
          className="introphotobig"
          src={intropicbig}
          alt="nothing to see here"
        ></img>

        <div className="introtextcontainer">
          <hr />
          <div className="introheading">Humanizing </div>
          <div className="introheading">your insurance. </div>
          <div className="introdetails">
            {" "}
            Get your life insurance coverage easier and faster. We blend our
            expertise and technology to help you find the plan that’s right for
            you. Ensure you and your loved ones are protected.
          </div>
          <div className="viewplansbtn">view plans</div>
        </div>
      </div>
    </>
  );
};

export default Introduction;
